var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "budgetDeatailDialog" },
    [
      _vm.costTableVisible
        ? _c("div", { staticClass: "maskDiv" }, [
            _c(
              "div",
              { staticClass: "costTable" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "sticky",
                      top: "0",
                      "z-index": "10",
                    },
                    attrs: { id: "headHeight-class" },
                  },
                  [
                    _c("div", { staticClass: "controlDiv" }, [
                      _vm.showType == 1
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                width: "10.25rem",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "margin-right": "2.5rem",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "controlDiv_button",
                                      on: {
                                        click: function ($event) {
                                          _vm.showCostTableHead = true
                                        },
                                      },
                                    },
                                    [_vm._v("打开数据汇总板")]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-down",
                                    staticStyle: {
                                      "font-size": "18px",
                                      color: "#ddd",
                                      "margin-left": "5px",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "controlDiv_button",
                                      on: {
                                        click: function ($event) {
                                          _vm.showCostTableHead = false
                                        },
                                      },
                                    },
                                    [_vm._v("收起数据汇总板")]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-up",
                                    staticStyle: {
                                      "font-size": "18px",
                                      color: "#ddd",
                                      "margin-left": "5px",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "shareIcon_box" },
                        [
                          _c("svg-icon", {
                            staticStyle: { width: "26px", height: "26px" },
                            attrs: { iconClass: "share1" },
                          }),
                          _vm.showType == 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "saveCostTable",
                                  on: {
                                    click: function ($event) {
                                      return _vm.saveBudget()
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "saveCostTable",
                              on: {
                                click: function ($event) {
                                  return _vm.saveBudget("close")
                                },
                              },
                            },
                            [_vm._v("保存并关闭")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "saveCostTable",
                              staticStyle: { width: "0.74rem" },
                              on: { click: _vm.closeDialog },
                            },
                            [_vm._v("关闭")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm.showType == 1
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showCostTableHead,
                                  expression: "showCostTableHead",
                                },
                              ],
                              staticClass: "costTableHead",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("div", { staticClass: "info_box" }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "0.3rem",
                                          },
                                        },
                                        [_vm._v("行程编号：")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "0.15rem",
                                            "margin-right": "0.3rem",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.chenckBudget.planId)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "border-left": "2px solid #bbb",
                                            "border-right": "2px solid #bbb",
                                            padding: "0 0.3rem",
                                            "max-width": "4.2rem",
                                            overflow: "hidden",
                                            "white-space": "nowrap",
                                            "text-overflow": "ellipsis",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.chenckBudget.planName)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "0.3rem",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.dateFormatYMD(
                                                  _vm.chenckBudget
                                                    .departureDate,
                                                  "/"
                                                )
                                              ) +
                                              "-" +
                                              _vm._s(
                                                _vm.dateFormatYMD(
                                                  _vm
                                                    .dateAddDay(
                                                      _vm.chenckBudget
                                                        .departureDate,
                                                      _vm.chenckBudget.planDay -
                                                        1
                                                    )
                                                    .getTime(),
                                                  "/"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "costTableHead_body" },
                                      [
                                        _c("div", [
                                          _c(
                                            "div",
                                            { staticClass: "appraiser_box" },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "appraiser_info",
                                                  },
                                                  [
                                                    _vm._m(0),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "appraiser_info_right",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_box_right",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "info_name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .planDetail
                                                                      .createName
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c("div", {
                                                              staticClass:
                                                                "info_avatar",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._m(1),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "quotation_box",
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "235px",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.chenckBudget
                                                              .quotation,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.chenckBudget,
                                                              "quotation",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "chenckBudget.quotation",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.planDetail
                                                          .budgetMains,
                                                        function (item, index) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: index,
                                                              attrs: {
                                                                label:
                                                                  _vm.dateFormatYMDHM(
                                                                    item.updateTime,
                                                                    "-"
                                                                  ) + "报价",
                                                                value: item.id,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "blueButton",
                                                      },
                                                      [_vm._v("收款设置")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "7rem",
                                              height: "2.63rem",
                                              "margin-left": "0.1rem",
                                              "margin-top": "0.2rem",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "space-between",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "stroke_info_item",
                                                    staticStyle: {
                                                      width: "2.24rem",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.chenckBudget
                                                                .planDay
                                                            )
                                                          ),
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.14rem",
                                                              color:
                                                                "rgba(86, 89, 118, 100)",
                                                            },
                                                          },
                                                          [_vm._v("天数")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.chenckBudget
                                                                .countrySize
                                                            )
                                                          ),
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.14rem",
                                                              color:
                                                                "rgba(86, 89, 118, 100)",
                                                            },
                                                          },
                                                          [_vm._v("国家")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.chenckBudget
                                                                .citySize
                                                            )
                                                          ),
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.14rem",
                                                              color:
                                                                "rgba(86, 89, 118, 100)",
                                                            },
                                                          },
                                                          [_vm._v("城市")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "stroke_info_item",
                                                    staticStyle: {
                                                      width: "4.61rem",
                                                      "justify-content":
                                                        "space-between",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "0.75rem",
                                                              height: "0.35rem",
                                                              background:
                                                                "rgba(219, 78, 26, 0.6)",
                                                              "text-align":
                                                                "center",
                                                              "line-height":
                                                                "0.35rem",
                                                              color: "white",
                                                              "font-size":
                                                                "0.16rem",
                                                            },
                                                          },
                                                          [_vm._v("核算人数")]
                                                        ),
                                                        _c("el-input", {
                                                          staticStyle: {
                                                            width: "0.75rem",
                                                            height: "0.34rem",
                                                            "margin-top":
                                                              "0.05rem",
                                                          },
                                                          attrs: {
                                                            size: "small",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.chenckBudget
                                                                .useNumber,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.chenckBudget,
                                                                "useNumber",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "chenckBudget.useNumber",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.2rem",
                                                              color:
                                                                "rgba(255, 98, 0, 100)",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .chenckBudget
                                                                    .useNumber ==
                                                                    ""
                                                                    ? _vm
                                                                        .dataObj
                                                                        .totalPrice
                                                                    : parseInt(
                                                                        _vm
                                                                          .dataObj
                                                                          .totalPrice /
                                                                          _vm
                                                                            .chenckBudget
                                                                            .useNumber
                                                                      )
                                                                ) +
                                                                "￥ "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.12rem",
                                                              color:
                                                                "rgba(86, 89, 118, 100)",
                                                              "margin-top":
                                                                "0.05rem",
                                                            },
                                                          },
                                                          [_vm._v("成本/人")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.2rem",
                                                              color:
                                                                "rgba(230, 76, 101, 100)",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .chenckBudget
                                                                    .useNumber ==
                                                                    ""
                                                                    ? _vm
                                                                        .dataObj
                                                                        .totalPrice
                                                                    : parseInt(
                                                                        _vm
                                                                          .dataObj
                                                                          .saleTotalPrice /
                                                                          _vm
                                                                            .chenckBudget
                                                                            .useNumber
                                                                      )
                                                                ) +
                                                                "￥ "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.12rem",
                                                              color:
                                                                "rgba(86, 89, 118, 100)",
                                                              "margin-top":
                                                                "0.05rem",
                                                            },
                                                          },
                                                          [_vm._v("报价/人")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "distanceInfo",
                                                        staticStyle: {
                                                          "align-items":
                                                            "flex-start",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.2rem",
                                                              color:
                                                                "rgba(230, 76, 101, 100)",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm
                                                                    .chenckBudget
                                                                    .useNumber ==
                                                                    ""
                                                                    ? parseInt(
                                                                        _vm
                                                                          .dataObj
                                                                          .saleTotalPrice -
                                                                          _vm
                                                                            .dataObj
                                                                            .totalPrice
                                                                      )
                                                                    : parseInt(
                                                                        (_vm
                                                                          .dataObj
                                                                          .saleTotalPrice -
                                                                          _vm
                                                                            .dataObj
                                                                            .totalPrice) /
                                                                          _vm
                                                                            .chenckBudget
                                                                            .useNumber
                                                                      )
                                                                ) +
                                                                "￥ "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.12rem",
                                                              color:
                                                                "rgba(86, 89, 118, 100)",
                                                              "margin-top":
                                                                "0.05rem",
                                                              "line-height":
                                                                "0.16rem",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "0.16rem",
                                                                  color:
                                                                    "rgba(255, 98, 0, 100)",
                                                                  "margin-right":
                                                                    "0.05rem",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      parseInt(
                                                                        _vm
                                                                          .dataObj
                                                                          .saleTotalPrice
                                                                      ) == 0 &&
                                                                        parseInt(
                                                                          _vm
                                                                            .dataObj
                                                                            .saleTotalPrice
                                                                        ) == 0
                                                                        ? 0
                                                                        : parseInt(
                                                                            ((_vm
                                                                              .dataObj
                                                                              .saleTotalPrice -
                                                                              _vm
                                                                                .dataObj
                                                                                .totalPrice) /
                                                                              _vm
                                                                                .dataObj
                                                                                .saleTotalPrice) *
                                                                              100
                                                                          )
                                                                    ) +
                                                                    "%"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "利润(率)/人 "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "space-between",
                                                  "margin-top": "0.12rem",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "price_item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "price_item_box",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v("总成本"),
                                                        ]),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              parseInt(
                                                                _vm.dataObj
                                                                  .totalPrice
                                                              )
                                                            ) + "￥"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._m(2),
                                                    _vm._m(3),
                                                    _vm._m(4),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "price_item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "price_item_box",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v("总报价"),
                                                        ]),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              parseInt(
                                                                _vm.dataObj
                                                                  .saleTotalPrice
                                                              )
                                                            ) + "￥"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._m(5),
                                                    _vm._m(6),
                                                    _vm._m(7),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "price_item" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "price_item_box",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v("预计利润"),
                                                        ]),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              parseInt(
                                                                _vm.dataObj
                                                                  .saleTotalPrice -
                                                                  _vm.dataObj
                                                                    .totalPrice
                                                              )
                                                            ) + "￥"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "price_item_box",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v("预计利润率"),
                                                        ]),
                                                        _c("div", [
                                                          _vm._v(
                                                            _vm._s(
                                                              parseInt(
                                                                _vm.dataObj
                                                                  .totalPrice
                                                              ) == 0 &&
                                                                parseInt(
                                                                  _vm.dataObj
                                                                    .saleTotalPrice
                                                                ) == 0
                                                                ? 0
                                                                : parseInt(
                                                                    ((_vm
                                                                      .dataObj
                                                                      .saleTotalPrice -
                                                                      _vm
                                                                        .dataObj
                                                                        .totalPrice) /
                                                                      _vm
                                                                        .dataObj
                                                                        .saleTotalPrice) *
                                                                      100
                                                                  )
                                                            ) + "%"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._m(8),
                                                    _vm._m(9),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._m(10),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      height: "80px",
                      background: "rgb(229, 129, 92)",
                      "align-items": "center",
                      padding: "0 0.2rem",
                      width: "14.5rem",
                      "border-bottom": "3px solid #E65019",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "7.5rem", position: "relative" },
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "order_list" },
                          _vm._l(_vm.orderType, function (item, index) {
                            return _c("li", { key: index }, [
                              _vm.checkedOrderType != index
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "line-height": "0.35rem",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.searchOrder(item, index)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(item.type))]
                                  )
                                : _c(
                                    "div",
                                    {
                                      style: `position:relative;width:${
                                        _vm.showType == 2 ? "1.25" : "1.75"
                                      }rem;`,
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "checkedItem_outer",
                                          style: `width:${
                                            _vm.showType == 2 ? "1" : "1.5"
                                          }rem`,
                                        },
                                        [
                                          item.closeButton == false &&
                                          _vm.showType == 1
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(102, 128, 244)",
                                                    width: "0.45rem",
                                                    "line-height": "0.35rem",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.restoreInfoByType(
                                                        item,
                                                        index,
                                                        false
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 恢复 ")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              class: item.closeButton
                                                ? "checkedItem_inside"
                                                : "checkedItem_inside_close",
                                            },
                                            [_vm._v(_vm._s(item.type))]
                                          ),
                                          item.closeButton && _vm.showType == 1
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "black",
                                                    width: "0.45rem",
                                                    "text-align": "right",
                                                    "line-height": "35px",
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.restoreInfoByType(
                                                        item,
                                                        index,
                                                        true
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" 关闭 ")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      item.type != "服务费" &&
                                      item.type != "税费" &&
                                      item.type != "其他" &&
                                      _vm.showType == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "-0.11rem",
                                                right: "0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "0.24rem",
                                                    height: "0.19rem",
                                                    cursor: "pointer",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/png/1.png"),
                                                      alt: "",
                                                      width: "100%",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteBudgetAll(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "0.2rem",
                                                    height: "0.19rem",
                                                    cursor: "pointer",
                                                    margin:
                                                      "0.02rem 0 0.02rem 0.04rem",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/png/2.png"),
                                                      alt: "",
                                                      width: "100%",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.showprofitVisible,
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._m(11, true),
                                            ]
                                          )
                                        : _vm._e(),
                                      (item.type == "服务费" ||
                                        item.type == "税费" ||
                                        item.type == "其他") &&
                                      _vm.showType == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "5px",
                                                right: "0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "20px",
                                                    height: "19px",
                                                    cursor: "pointer",
                                                    margin: "2px 0 2px 4px",
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/png/addService.png"),
                                                      alt: "",
                                                      width: "100%",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addService(
                                                          item.type
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                            ])
                          }),
                          0
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              position: "absolute",
                              right: "-80px",
                              top: "0",
                            },
                            attrs: { type: "success", round: "" },
                            on: { click: _vm.allCreateOrder },
                          },
                          [_vm._v(" 预订 ")]
                        ),
                      ],
                      1
                    ),
                    _c("div", {
                      staticStyle: {
                        width: "5.2rem",
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    }),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: {
                      width: "14.5rem",
                      color: "black",
                      padding: "0",
                      "font-size": "0.12rem",
                    },
                    attrs: {
                      "span-method": _vm.arraySpanMethod,
                      data: _vm.tableList,
                      "summary-method": _vm.costTableGetSummaries,
                      border: "",
                      "show-summary": "",
                      height: _vm.myHeight,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "budgetType", label: "项目", width: "58" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "产品名称",
                        width: "120",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                (scope.row.state == 12 ||
                                  scope.row.state == 13 ||
                                  scope.row.state == 14) &&
                                scope.row.status != 1
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: scope.row.productName,
                                          expression: "scope.row.productName",
                                        },
                                      ],
                                      domProps: {
                                        value: scope.row.productName,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            scope.row,
                                            "productName",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "costTableItem" },
                                        [_vm._v(_vm._s(scope.row.productName))]
                                      ),
                                      scope.row.oldProductName
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(scope.row.oldProductName)
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3857618910
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "说明",
                        width: "120",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                (scope.row.state == 12 ||
                                  scope.row.state == 13 ||
                                  scope.row.state == 14) &&
                                scope.row.status != 1
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            scope.row.stockDetailObj
                                              .productDesc,
                                          expression:
                                            "scope.row.stockDetailObj.productDesc",
                                        },
                                      ],
                                      domProps: {
                                        value:
                                          scope.row.stockDetailObj.productDesc,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            scope.row.stockDetailObj,
                                            "productDesc",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "costTableItem" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.stockDetailObj.productDesc
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3470059206
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "入住城市",
                        width: "50",
                        "show-overflow-tooltip": "",
                        prop: "cityName",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "单位", width: "50" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                (scope.row.state == 12 ||
                                  scope.row.state == 13 ||
                                  scope.row.state == 14) &&
                                scope.row.status != 1
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            scope.row.stockDetailObj
                                              .priceList[0].priceCompany,
                                          expression:
                                            "scope.row.stockDetailObj.priceList[0].priceCompany",
                                        },
                                      ],
                                      domProps: {
                                        value:
                                          scope.row.stockDetailObj.priceList[0]
                                            .priceCompany,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            scope.row.stockDetailObj
                                              .priceList[0],
                                            "priceCompany",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "costTableItem" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.stockDetailObj
                                              .priceList[0].priceCompany
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3889657857
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "时长", width: "60" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                (scope.row.state == 12 ||
                                  scope.row.state == 13 ||
                                  scope.row.state == 14) &&
                                scope.row.status != 1
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            scope.row.stockDetailObj
                                              .priceList[0].useTime,
                                          expression:
                                            "scope.row.stockDetailObj.priceList[0].useTime",
                                        },
                                      ],
                                      domProps: {
                                        value:
                                          scope.row.stockDetailObj.priceList[0]
                                            .useTime,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            scope.row.stockDetailObj
                                              .priceList[0],
                                            "useTime",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "costTableItem" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.stockDetailObj
                                              .priceList[0].timeDesc
                                              ? scope.row.stockDetailObj
                                                  .priceList[0].timeDesc
                                              : scope.row.stockDetailObj
                                                  .priceList[0].useTime
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        222656376
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "使用日期", width: "92" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                (scope.row.state == 12 ||
                                  scope.row.state == 13 ||
                                  scope.row.state == 14) &&
                                scope.row.status != 1
                                  ? _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: scope.row.stayDate,
                                            expression: "scope.row.stayDate",
                                          },
                                        ],
                                        staticStyle: { width: "95%" },
                                        attrs: { placeholder: "请选择" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              scope.row,
                                              "stayDate",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(
                                        _vm.chenckBudget.planDayList,
                                        function (item, index) {
                                          return _c("option", {
                                            key: index,
                                            attrs: {
                                              label: _vm.dateFormatYMD(
                                                item.planDate,
                                                "-"
                                              ),
                                            },
                                            domProps: {
                                              value: _vm.dateFormatYMD(
                                                item.planDate,
                                                "-"
                                              ),
                                            },
                                          })
                                        }
                                      ),
                                      0
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "costTableItem" },
                                      [_vm._v(_vm._s(scope.row.stayDate))]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1875677518
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "数量",
                        prop: "serviceNumber",
                        width: "40",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                    },
                                  },
                                  [
                                    scope.row.status == 1 ||
                                    _vm.showType == 2 ||
                                    scope.row.orderBudgetId
                                      ? _c(
                                          "div",
                                          { staticClass: "costTableItem" },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.stockNumber)
                                            ),
                                          ]
                                        )
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: scope.row.stockNumber,
                                              expression:
                                                "scope.row.stockNumber",
                                            },
                                          ],
                                          domProps: {
                                            value: scope.row.stockNumber,
                                          },
                                          on: {
                                            input: [
                                              function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  scope.row,
                                                  "stockNumber",
                                                  $event.target.value
                                                )
                                              },
                                              function ($event) {
                                                return _vm.changeServiceNumber(
                                                  scope.row
                                                )
                                              },
                                            ],
                                          },
                                        }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        554738825
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "成本(原币)",
                        prop: "price",
                        width: "72",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                (scope.row.state == 12 ||
                                  scope.row.state == 13 ||
                                  scope.row.state == 14) &&
                                scope.row.status != 1
                                  ? _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: scope.row.stockPrice,
                                              expression:
                                                "scope.row.stockPrice",
                                            },
                                          ],
                                          staticStyle: {
                                            "font-size": "12px",
                                            width: "47%",
                                            "margin-top": "0.02rem",
                                          },
                                          domProps: {
                                            value: scope.row.stockPrice,
                                          },
                                          on: {
                                            input: [
                                              function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  scope.row,
                                                  "stockPrice",
                                                  $event.target.value
                                                )
                                              },
                                              function ($event) {
                                                return _vm.changeServiceNumber(
                                                  scope.row
                                                )
                                              },
                                            ],
                                          },
                                        }),
                                        _c("currency-autocomplete", {
                                          attrs: {
                                            obj: scope.row,
                                            styleStr: "width:47%",
                                          },
                                          on: {
                                            currencySelect: function ($event) {
                                              return _vm.currencySelect(
                                                $event,
                                                scope.row
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "costTableItem" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.stockPrice +
                                              scope.row.currency
                                          )
                                        ),
                                      ]
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2662198138
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "报价(原币)",
                        prop: "salePrice",
                        width: "72",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "qutationDiv",
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                    },
                                  },
                                  [
                                    scope.row.status != 1 && _vm.showType == 1
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: scope.row.ratio,
                                              expression: "scope.row.ratio",
                                            },
                                          ],
                                          domProps: { value: scope.row.ratio },
                                          on: {
                                            input: [
                                              function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  scope.row,
                                                  "ratio",
                                                  $event.target.value
                                                )
                                              },
                                              function ($event) {
                                                return _vm.changeServiceNumber(
                                                  scope.row
                                                )
                                              },
                                            ],
                                          },
                                        })
                                      : _c(
                                          "div",
                                          { staticClass: "costTableItem" },
                                          [_vm._v(_vm._s(scope.row.ratio))]
                                        ),
                                    _c("div", [
                                      _vm._v(_vm._s(scope.row.currency)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1971232774
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "利润", prop: "profit", width: "55" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _c("div", { staticClass: "costTableItem" }, [
                                    _vm._v(
                                      _vm._s(
                                        Number(
                                          (
                                            scope.row.ratio -
                                            scope.row.stockPrice
                                          ).toFixed(2)
                                        ) + scope.row.currency
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2210640997
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "利润率",
                        prop: "profitMargin",
                        width: "55",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _c("div", { staticClass: "costTableItem" }, [
                                    _vm._v(
                                      _vm._s(
                                        Number(
                                          (
                                            ((scope.row.ratio -
                                              scope.row.stockPrice) /
                                              scope.row.ratio) *
                                            100
                                          ).toFixed(3)
                                        ) + "%"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2188024370
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "总成本(原币)", width: "75" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "costTableItem" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.stockPrice *
                                        scope.row.stockNumber +
                                        scope.row.currency
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1477253054
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "总报价(原币)", width: "75" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "costTableItem" }, [
                                  _vm._v(
                                    _vm._s(
                                      Number(
                                        (
                                          scope.row.ratio *
                                          scope.row.stockNumber
                                        ).toFixed(2)
                                      ) + scope.row.currency
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3604189248
                      ),
                    }),
                    _c(
                      "el-table-column",
                      {
                        attrs: { width: "63" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.status == 1 || _vm.showType == 2
                                    ? _c(
                                        "div",
                                        { staticClass: "costTableItem" },
                                        [_vm._v(_vm._s(scope.row.rate))]
                                      )
                                    : _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: scope.row.rate,
                                            expression: "scope.row.rate",
                                          },
                                        ],
                                        domProps: { value: scope.row.rate },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeRate(scope.row)
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              scope.row,
                                              "rate",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          666749373
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("p", [_vm._v("汇率")]),
                          _c(
                            "p",
                            { staticStyle: { transform: "scale(0.8)" } },
                            [
                              _vm.showType == 1
                                ? _c(
                                    "a",
                                    {
                                      staticStyle: { color: "blue" },
                                      on: {
                                        click: function ($event) {
                                          _vm.currencyVisible = true
                                        },
                                      },
                                    },
                                    [_vm._v("更新汇率")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      attrs: { label: "总成本(￥)", width: "92" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "costTableItem" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.stockPrice *
                                        scope.row.stockNumber *
                                        scope.row.rate +
                                        "￥"
                                    )
                                  ),
                                  _c("br"),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2288047637
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "总报价(￥)", width: "92" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "costTableItem" }, [
                                  _vm._v(
                                    _vm._s(
                                      Number(
                                        (
                                          scope.row.ratio *
                                          scope.row.stockNumber *
                                          scope.row.rate
                                        ).toFixed(2)
                                      ) + "￥"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2004598314
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "总利润(￥)", width: "80" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", { staticClass: "costTableItem" }, [
                                  _vm._v(
                                    _vm._s(
                                      Number(
                                        (
                                          scope.row.ratio *
                                            scope.row.stockNumber *
                                            scope.row.rate -
                                          scope.row.stockPrice *
                                            scope.row.stockNumber *
                                            scope.row.rate
                                        ).toFixed(2)
                                      ) + "￥"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4221631307
                      ),
                    }),
                    _c(
                      "el-table-column",
                      {
                        key: _vm.checkAllFlag,
                        attrs: { width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm.showType == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "space-around",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "24px",
                                                height: "24px",
                                              },
                                            },
                                            [
                                              !scope.row.orderBudgetId
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "costTableBoutton",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.singleCreateOrder(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("抢")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          !scope.row.orderBudgetId
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "costTableBoutton",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteBudget(
                                                        scope.row,
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删")]
                                              )
                                            : _vm._e(),
                                          _c("el-switch", {
                                            attrs: {
                                              "active-color": "#13ce66",
                                              "inactive-color": "#ddd",
                                              "active-value": 0,
                                              "inactive-value": 1,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeServiceNumber(
                                                  scope.row
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.status",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c("el-checkbox", {
                                            on: {
                                              change:
                                                _vm.handleCheckAllChangeSingle,
                                            },
                                            model: {
                                              value: scope.row.checkFlag,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "checkFlag",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.checkFlag",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3727702897
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _vm.showType == 1
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                    padding: "0 0.1rem",
                                  },
                                },
                                [
                                  _c("div", [_vm._v("操作")]),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _vm._v(" 是否"),
                                      _c("br"),
                                      _c("span", [_vm._v("加入预算")]),
                                    ]
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: { change: _vm.handleCheckAllChange },
                                      model: {
                                        value: _vm.checkAllFlag,
                                        callback: function ($$v) {
                                          _vm.checkAllFlag = $$v
                                        },
                                        expression: "checkAllFlag",
                                      },
                                    },
                                    [_vm._v("全选")]
                                  ),
                                ],
                                1
                              ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.profitVisible,
            modal: true,
            "show-close": false,
            title: "利润率批量调整",
            center: "",
            "close-on-click-modal": false,
            width: "357px;",
          },
          on: {
            "update:visible": function ($event) {
              _vm.profitVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#DB4E1A",
                    "font-weight": "bold",
                    display: "inline-block",
                    "text-align": "center",
                    width: "2.1rem",
                  },
                },
                [
                  _vm._v("提示：如果保存此处的数据，"),
                  _c("br"),
                  _vm._v("您之前录入的产品价格将被覆盖！"),
                ]
              ),
            ]
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "1px solid #ddd",
              margin: "0.15rem 0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "margin-bottom": "0.15rem",
              },
            },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.addProfitMethod,
                    callback: function ($$v) {
                      _vm.addProfitMethod = $$v
                    },
                    expression: "addProfitMethod",
                  },
                },
                [_vm._v("按利润率")]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: 2 },
                  model: {
                    value: _vm.addProfitMethod,
                    callback: function ($$v) {
                      _vm.addProfitMethod = $$v
                    },
                    expression: "addProfitMethod",
                  },
                },
                [_vm._v("按报价总价")]
              ),
            ],
            1
          ),
          _vm.checkedOrderType === 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    "padding-top": "0.2rem",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.addProfitMethod == 1,
                          expression: "addProfitMethod==1",
                        },
                      ],
                      staticStyle: {
                        "text-align": "center",
                        "font-weight": "bold",
                        color: "#101010",
                      },
                    },
                    [_vm._v("所有项目利润率"), _c("br"), _vm._v("快速录入")]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.addProfitMethod == 2,
                          expression: "addProfitMethod==2",
                        },
                      ],
                      staticStyle: {
                        "text-align": "center",
                        "font-weight": "bold",
                        color: "#101010",
                      },
                    },
                    [_vm._v("所有项目总价"), _c("br"), _vm._v("快速录入")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "0.7rem", "margin-left": "0.2rem" },
                    attrs: { size: "small" },
                    on: { input: _vm.changeAllProfit },
                    model: {
                      value: _vm.allProfitnNumber,
                      callback: function ($$v) {
                        _vm.allProfitnNumber = $$v
                      },
                      expression: "allProfitnNumber",
                    },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.addProfitMethod == 1,
                          expression: "addProfitMethod==1",
                        },
                      ],
                    },
                    [_vm._v("%")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "ul",
            { staticStyle: { "list-style": "none" } },
            _vm._l(_vm.budgetType, function (item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticStyle: {
                    "padding-top": "0.2rem",
                    display: "flex",
                    "justify-content": "center",
                  },
                },
                [
                  _vm.checkedOrderType === 0 ||
                  _vm.orderType[_vm.checkedOrderType].type == item.type
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { width: "1.4rem" },
                              model: {
                                value: item.isChecked,
                                callback: function ($$v) {
                                  _vm.$set(item, "isChecked", $$v)
                                },
                                expression: "item.isChecked",
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(item.type) + " "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.addProfitMethod == 2,
                                      expression: "addProfitMethod==2",
                                    },
                                  ],
                                },
                                [_vm._v(_vm._s(item.totalPrice) + "￥/人  ")]
                              ),
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "0.6rem",
                              "margin-left": "0.15rem",
                            },
                            attrs: { size: "small" },
                            on: {
                              input: function ($event) {
                                item.isChecked = true
                              },
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.addProfitMethod == 1,
                                  expression: "addProfitMethod==1",
                                },
                              ],
                            },
                            [_vm._v("%")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.profitVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveProfit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "serviceAddDialog",
          attrs: {
            visible: _vm.serviceVisible,
            modal: false,
            "show-close": false,
            title: "新增" + _vm.budgetTypeName,
            center: "",
            "close-on-click-modal": false,
            width: "450px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.serviceVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "margin-top": "0.15rem",
              },
            },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: 1 },
                  model: {
                    value: _vm.addServiceMethod,
                    callback: function ($$v) {
                      _vm.addServiceMethod = $$v
                    },
                    expression: "addServiceMethod",
                  },
                },
                [_vm._v("按整数维护")]
              ),
              _c(
                "el-radio",
                {
                  attrs: { label: 2 },
                  model: {
                    value: _vm.addServiceMethod,
                    callback: function ($$v) {
                      _vm.addServiceMethod = $$v
                    },
                    expression: "addServiceMethod",
                  },
                },
                [_vm._v("按比例维护")]
              ),
            ],
            1
          ),
          _vm.addServiceMethod === 2
            ? _c(
                "div",
                { staticClass: "serviceAddDiv" },
                [
                  _c("div", [
                    _vm._v("所有项目比例"),
                    _c("br"),
                    _vm._v("快速录入"),
                  ]),
                  _c("label", [
                    _vm._v("   " + _vm._s(_vm.dataObj.saleTotalPrice) + "￥"),
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "0.7rem", "margin-left": "0.1rem" },
                    attrs: { size: "small" },
                    on: { input: _vm.changeAllService },
                    model: {
                      value: _vm.allServiceNumber,
                      callback: function ($$v) {
                        _vm.allServiceNumber = $$v
                      },
                      expression: "allServiceNumber",
                    },
                  }),
                  _c("span", [_vm._v("%")]),
                  _c("span", [
                    _vm._v(
                      "   " +
                        _vm._s(Number(_vm.totalServiceFee.toFixed(2))) +
                        "￥"
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addServiceMethod == 1,
                  expression: "addServiceMethod==1",
                },
              ],
              staticStyle: { "text-align": "center" },
            },
            [
              _c("el-input", {
                staticStyle: { width: "1.6rem", "margin-top": "0.15rem" },
                attrs: {
                  size: "small",
                  placeholder: "请输入你要添加的服务费金额",
                },
                model: {
                  value: _vm.servicePrice,
                  callback: function ($$v) {
                    _vm.servicePrice = $$v
                  },
                  expression: "servicePrice",
                },
              }),
              _vm._v("  "),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addServiceMethod == 2,
                  expression: "addServiceMethod==2",
                },
              ],
            },
            _vm._l(_vm.budgetType, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "serviceAddDiv" },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: item.isChecked,
                            callback: function ($$v) {
                              _vm.$set(item, "isChecked", $$v)
                            },
                            expression: "item.isChecked",
                          },
                        },
                        [_vm._v(_vm._s(item.type))]
                      ),
                    ],
                    1
                  ),
                  _c("label", [
                    _vm._v("  " + _vm._s(item.totalPrice) + "￥  "),
                  ]),
                  _c("el-input", {
                    staticStyle: { width: "0.6rem", "margin-left": "0.15rem" },
                    attrs: { size: "small" },
                    on: {
                      input: function ($event) {
                        return _vm.changeService(item)
                      },
                    },
                    model: {
                      value: item.value,
                      callback: function ($$v) {
                        _vm.$set(item, "value", $$v)
                      },
                      expression: "item.value",
                    },
                  }),
                  _vm._v("  "),
                  _c("span", [_vm._v("%")]),
                  _c("span", [
                    _vm._v(
                      "   " +
                        _vm._s(
                          Number(
                            (item.totalPrice * (item.value / 100)).toFixed(2)
                          )
                        ) +
                        "￥"
                    ),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addServiceMethod == 2,
                  expression: "addServiceMethod==2",
                },
              ],
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "margin-top": "0.15rem",
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.addServiceDataMethod,
                        callback: function ($$v) {
                          _vm.addServiceDataMethod = $$v
                        },
                        expression: "addServiceDataMethod",
                      },
                    },
                    [_vm._v("按整笔生成(生成一笔数据)")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 2 },
                      model: {
                        value: _vm.addServiceDataMethod,
                        callback: function ($$v) {
                          _vm.addServiceDataMethod = $$v
                        },
                        expression: "addServiceDataMethod",
                      },
                    },
                    [_vm._v("按项目生成(按项目生成多笔数据)")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.serviceVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveService } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.currencyVisible,
            modal: true,
            "show-close": false,
            title: "汇率批量调整",
            center: "",
            "close-on-click-modal": false,
            width: "357px;",
          },
          on: {
            "update:visible": function ($event) {
              _vm.currencyVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#DB4E1A",
                    "font-weight": "bold",
                    display: "inline-block",
                    "text-align": "center",
                    width: "2.1rem",
                  },
                },
                [
                  _vm._v("提示：如果保存此处的数据，"),
                  _c("br"),
                  _vm._v("您之前录入的汇率将被覆盖！"),
                ]
              ),
            ]
          ),
          _c("div", {
            staticStyle: {
              "border-bottom": "1px solid #ddd",
              margin: "0.15rem 0",
            },
          }),
          _vm.currencies.length > 0
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _c(
                  "a",
                  {
                    staticStyle: { color: "blue" },
                    on: {
                      click: function ($event) {
                        return _vm.toOldRate()
                      },
                    },
                  },
                  [_vm._v("更新为系统最新汇率")]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      "font-weight": "bold",
                      color: "#101010",
                      "margin-top": "0.1rem",
                    },
                  },
                  [_vm._v("汇率快速录入")]
                ),
                _c(
                  "ul",
                  { staticStyle: { "list-style": "none" } },
                  _vm._l(_vm.currencies, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticStyle: {
                          "padding-top": "0.2rem",
                          display: "flex",
                          "justify-content": "center",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { width: "1.4rem" },
                                model: {
                                  value: item.isChecked,
                                  callback: function ($$v) {
                                    _vm.$set(item, "isChecked", $$v)
                                  },
                                  expression: "item.isChecked",
                                },
                              },
                              [_vm._v(" " + _vm._s(item.code) + " ")]
                            ),
                            _c("el-input", {
                              staticStyle: {
                                width: "0.6rem",
                                "margin-left": "0.15rem",
                              },
                              attrs: { size: "small" },
                              on: {
                                input: function ($event) {
                                  item.isChecked = true
                                },
                              },
                              model: {
                                value: item.value,
                                callback: function ($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.currencyVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveCurrency } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("createPreOrder", {
        ref: "orderPre",
        attrs: { id: "createPreOrder" },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "appraiser_info_box" }, [
      _c("div", { staticClass: "info_title" }, [_vm._v("座右铭")]),
      _c("div", { staticClass: "info_body" }, [
        _vm._v("性价比永远是开心出行的首要前提"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info_ability" }, [
      _c("div", [_vm._v("资深定制师")]),
      _c("div", [_vm._v("共计处理定制需求105件")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("确认中")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("已确认")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("待确认")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("客户已抢")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("客户实付")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("客户待付")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("实时利润")]),
      _c("div", [_vm._v("0￥")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price_item_box" }, [
      _c("div", [_vm._v("实时利润率")]),
      _c("div", [_vm._v("0")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pieChart" }, [
      _c("div", {
        staticStyle: { width: "3.53rem", height: "3.38rem" },
        attrs: { id: "pieChart" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: { width: "0.24rem", height: "0.19rem", cursor: "pointer" },
      },
      [
        _c("img", {
          attrs: { src: require("@/assets/png/3.png"), alt: "", width: "100%" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }